const Index = () => import('./components/index');
const Create = () => import('./components/create');
const Edit = () => import('./components/edit');
const Show = () => import('./components/show');

export default [
  {
    path: '/users',
    name: 'users.index',
    meta: {
      title: 'Usuários',
    },
    component: Index,
  },
  {
    path: '/users/create',
    name: 'users.create',
    meta: {
      title: 'Adicionar usuário',
    },
    component: Create,
  },
  {
    path: '/users/:id/edit',
    name: 'users.edit',
    meta: {
      title: 'Editar usuário',
    },
    component: Edit,
  },
  {
    path: '/users/:id',
    name: 'users.show',
    meta: {
      title: 'Ver usuário',
    },
    component: Show,
  },
];
